// T22.201: dependency-free home of the Build Menu tile-icon lookup.
// utils/helpers.js (imported by almost every module) reads it for
// getWidgetDetails; constants/segmentTools.js fills it when the builder
// toolbox loads. Keeping it here stops helpers.js from importing segmentTools,
// which drags the whole SegmentBuilder/Froala/react-icons tree into main.js.
export const TILE_ICON_BY_WIDGET_NAME = {};
